import React, { useContext, useEffect, useState } from 'react';
import clsx from 'clsx';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import { AuthContext, useAuth } from '../../contexts/AuthContext';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { withStyles } from '@material-ui/core/styles';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useNavigate } from 'react-router-dom';
import logoBlack from '../../img/CS-Logo-black.png';
import logoWhite from '../../img/CS-Logo-white.png';
import Link from '@material-ui/core/Link';
import { db } from '../../firebase';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const drawerWidth = 270;
const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  menuButtonHidden: {
    display: 'none',
  },
  hide: {
    display: 'none',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    zIndex: theme.zIndex.drawer + 1,
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    color: 'white',
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  title: {
    flexGrow: 1,
    marginLeft: '10px',
  },
  signOut: {
    marginRight: '20px',
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  logo: {
    height: '50px',
  },
}));

interface Props {
  children: React.ReactElement;
}
function ElevationScroll(props: Props) {
  const { children } = props;
  const trigger = useScrollTrigger();
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
    color: trigger ? 'primary' : 'transparent',
    textColor: 'black',
  });
}
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles(() => ({}))(MenuItem);

export function UserHeader(props) {
  // const icon = !props.darkMode ? <Brightness7Icon /> : <Brightness3Icon />;
  const classes = useStyles();
  const { currentUser, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const menuId = 'primary-search-account-menu';
  const mobileMenuId = 'primary-search-account-menu-mobile';
  const navigate = useNavigate();
  const [profileInfo, setProfileInfo] = useState<any>();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const profile = async () => {
      const info = await db.collection('profile').doc(currentUser.uid).get();
      setProfileInfo(info.data());
    };
    profile().then();
  }, []);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    handleMobileMenuClose();
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
    handleMenuClose();
  };

  const renderMenu = (
    <StyledMenu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      elevation={5}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {profileInfo && profileInfo.role === 'admin' && (
        <StyledMenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(`/app/dashboard`);
          }}
        >
          <ListItemIcon>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </StyledMenuItem>
      )}
      <StyledMenuItem
        onClick={() => {
          setAnchorEl(null);
          navigate(`/app/profile`);
        }}
      >
        <ListItemIcon>
          <AccountCircleIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="My Profile" />
      </StyledMenuItem>
      <StyledMenuItem
        onClick={() => {
          setAnchorEl(null);
          logout();
        }}
      >
        <ListItemIcon>
          <ExitToAppIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Log Out" />
      </StyledMenuItem>
    </StyledMenu>
  );
  const renderMobileMenu = (
    <StyledMenu
      anchorEl={mobileMoreAnchorEl}
      id={mobileMenuId}
      keepMounted
      open={isMobileMenuOpen}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      onClose={handleMobileMenuClose}
    >
      {profileInfo && profileInfo.role === 'admin' && (
        <StyledMenuItem
          onClick={() => {
            setMobileMoreAnchorEl(null);
            navigate(`/app/dashboard`);
          }}
        >
          <ListItemIcon>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </StyledMenuItem>
      )}
      <StyledMenuItem
        onClick={() => {
          setMobileMoreAnchorEl(null);
          navigate(`/app/profile`);
        }}
      >
        <ListItemIcon>
          <AccountCircleIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="My Profile" />
      </StyledMenuItem>
      <StyledMenuItem
        onClick={() => {
          setMobileMoreAnchorEl(null);
          logout();
        }}
      >
        <ListItemIcon>
          <ExitToAppIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Log Out" />
      </StyledMenuItem>
    </StyledMenu>
  );

  return (
    <div>
      <ElevationScroll {...props}>
        <AppBar
          elevation={0}
          color={currentUser ? 'primary' : 'transparent'}
          position="fixed"
          style={{ background: 'primary' }}
          className={clsx({
            [classes.appBarShift]: props.open,
            [classes.appBar]: !props.open,
          })}
        >
          <Toolbar variant="regular" className={classes.toolbar}>
            <IconButton
              color={useScrollTrigger() ? 'inherit' : matches ? 'inherit' : 'default'}
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
              edge="start"
              className={clsx({
                [classes.menuButtonHidden]: props.open,
                [classes.menuButton]: !props.open,
              })}
            >
              <MenuIcon />
            </IconButton>
            <Link href="/app/">
              <img src={logoWhite} alt="CS Logo" className={classes.logo} />
            </Link>

            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              <IconButton aria-label="show 17 new notifications" color="inherit">
                <Badge badgeContent={4} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton aria-label="show 17 new notifications" color="inherit">
                <Badge badgeContent={4} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </div>
            {/*Dark theme functionality. */}
            {/*<IconButton*/}
            {/*    edge="end"*/}
            {/*    color='inherit'*/}
            {/*    aria-label="mode"*/}
            {/*    onClick={props.toggleDarkMode}*/}
            {/*>*/}
            {/*  {icon}*/}
            {/*</IconButton>*/}
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
